import { useEffect, useState } from 'react';

export function DelayedViewer(props) {
    const [show, setShow] = useState(props.show);

    useEffect(() => {
        if (props.delay && show && !props.show) // delay only at disapearing
            setTimeout(() => setShow(props.show), props.delay);
        else if (show !== props.show)
            setShow(props.show);
    }, [props.show, props.delay, show]);
    
    return show ? props.children : null;
}
